var map = {
	"./general/logo/digiwin_logo40.svg": "3ad3",
	"./general/logo/imgLogo.png": "d116",
	"./general/logo/ximgLogo.png": "d476",
	"./general/logo/ximgLogo@2x.png": "5bd7",
	"./general/logo/ximgLogo@3x.png": "15c6",
	"./general/logo/xlogo_dark.png": "9bfd",
	"./mobile/head/banner.png": "501c",
	"./mobile/head/banner@2x.png": "d80d",
	"./mobile/head/banner@3x.png": "c3e4",
	"./mobile/head/bgHeaderPlaceholder.png": "07d7",
	"./mobile/head/bgHeaderPlaceholder@2x.png": "aa79",
	"./mobile/head/bgHeaderPlaceholder@3x.png": "5709",
	"./pc/head/banner.png": "3b5c",
	"./pc/head/banner@2x.png": "8284",
	"./pc/head/banner@3x.png": "1487",
	"./pc/head/bgHeaderPlaceholder.png": "783e",
	"./pc/head/bgHeaderPlaceholder@2x.png": "4d7f",
	"./pc/head/bgHeaderPlaceholder@3x.png": "22b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8ec1";